import { CsValidationForm } from "../../shared/csValidationForm";
import { Card, FormLayout, Layout } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import TooltipHelper from "../../helpers/TooltipHelper";
import Switch from "react-switch/index";
import ChoiceListWithChildren from "../ChoiceListWithChildren";
import React from "react";

const PrivacyMarketing = props => {
  const {
    validatorClass,
    analyticActive, analytics,
    emailMarketingActive, emailMarketing,
    remarketingActive, remarketing,
    handleChange, handleChoiceListChange, handleChangeTextFieldOfChoice,
  } = props;

  let mainCard =
    <CsValidationForm name={validatorClass} realtime={true}>
      <Card>
        <Card.Section>
          <FormLayout>
            <p>
              <CsI18n>Analytics</CsI18n>
              {TooltipHelper.light(CsI18n.t('privacy.explain.analytics'))}
            </p>
            <Switch
              className="react-switch"
              onChange={handleChange('analyticActive')}
              checked={analyticActive}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t("Analytics")}
            />
            {analyticActive &&
            <ChoiceListWithChildren
              title={''}
              choices={analytics}
              masterListKey={'analytics'}
              subListKeys={[]}
              handleChoiceListChange={handleChoiceListChange}
              handleChangeTextFieldOfChoice={handleChangeTextFieldOfChoice}
            />
            }
          </FormLayout>
        </Card.Section>

        <Card.Section>
          <FormLayout>
            <p><CsI18n>Email marketing</CsI18n> - B2C</p>
            <Switch
              className="react-switch"
              onChange={handleChange('emailMarketingActive')}
              checked={emailMarketingActive}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t("Email marketing")}
            />
            {emailMarketingActive &&
            <ChoiceListWithChildren
              title={''}
              choices={emailMarketing}
              masterListKey={'emailMarketing'}
              subListKeys={[]}
              handleChoiceListChange={handleChoiceListChange}
              handleChangeTextFieldOfChoice={handleChangeTextFieldOfChoice}
            />
            }
          </FormLayout>
        </Card.Section>

        <Card.Section>
          <FormLayout>
            <p><CsI18n>Remarketing</CsI18n> - B2C</p>
            <Switch
              className="react-switch"
              onChange={handleChange('remarketingActive')}
              checked={remarketingActive}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t("Remarketing")}
            />
            {remarketingActive &&
            <ChoiceListWithChildren
              title={''}
              choices={remarketing}
              masterListKey={'remarketing'}
              subListKeys={[]}
              handleChoiceListChange={handleChoiceListChange}
              handleChangeTextFieldOfChoice={handleChangeTextFieldOfChoice}
            />}
          </FormLayout>
        </Card.Section>
      </Card>
    </CsValidationForm>

  return (
    <Layout.AnnotatedSection description={CsI18n.t("privacy.annotate.desc.marketing")}>
      {mainCard}
    </Layout.AnnotatedSection>
  );
};

export default PrivacyMarketing;